import { createStore } from "jotai";

export const globalJotaiStore = createStore();
